import "../../App.css";
import React from "react";
import ORAL_SURGERY from '../ORAL_SURGERY';
import CONTACT_US from '../footer';
import Accordian from '../../accordian/accordian'
import BackBtn from '../BackBtn';
import ScrollArrow from '../ScrollUp';

function ORAL_SURGERY_Page() {
    return(
    <>
        <ORAL_SURGERY/>  
        <Accordian
         title="How long does oral surgery takes" 
         content="  For example, wisdom tooth extraction or root trench treatment may take around about fourteen days. Jaw medical procedure can take as long as five hours, and it might take about months as well."
       />
       <Accordian
         title=" Is oral surgery painful" 
         content="    After minor oral medical procedure, you may have draining and swelling. Appropriate consideration after oral medical procedure will enable your mouth to mend rapidly and neatly. This is what more often than not occurs after oral medical procedure and how you can manage it. Once the analgesic (solidifying) wears off, feeling some distress is typical."
       />
         <BackBtn/>
         <CONTACT_US/>
         <ScrollArrow/>
    </>
    )
}
export default ORAL_SURGERY_Page;